import { IconComponent } from '~harmony/components'

import IconSVG from '../../assets/icons/UserFollowing.svg'

export const IconUserFollowing = IconSVG as IconComponent
